import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppShell from './components/AppShell';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CourseCataloguePage from './pages/CourseCataloguePage';
import TimetablePage from './pages/TimetablePage';
import WorkflowPage from './pages/WorkflowPage';
import LecturersPage from './pages/LecturersPage';
import ClassroomsPage from './pages/ClassroomsPage';
import AiTourismPage from './pages/AiTourismPage';
import SocialMediaPage from './pages/SocialMediaPage';
import ReportsPage from './pages/ReportsPage';
import AuditPage from './pages/AuditPage';
import SettingsPage from './pages/SettingsPage';
import ProfilePage from './pages/ProfilePage';
import ModuleMasterPage from './pages/ModuleMasterPage';
import CourseLevelPage from './pages/CourseLevelPage';
import IntakeMasterPage from './pages/IntakeMasterPage';
import ComponentMasterPage from './pages/ComponentMasterPage';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route element={<ProtectedRoute />}>
                <Route element={<AppShell />}>
                  <Route path="/" element={<DashboardPage />} />
                  <Route path="/catalogue" element={<CourseCataloguePage />} />
                  <Route path="/course-levels" element={<CourseLevelPage />} />
                  <Route path="/intakes" element={<IntakeMasterPage />} />
                  <Route path="/components" element={<ComponentMasterPage />} />
                  <Route path="/timetable" element={<TimetablePage />} />
                  <Route path="/workflow" element={<WorkflowPage />} />
                  <Route path="/lecturers" element={<LecturersPage />} />
                  <Route path="/classrooms" element={<ClassroomsPage />} />
                  <Route path="/ai" element={<AiTourismPage />} />
                  <Route path="/social" element={<SocialMediaPage />} />
                  <Route path="/modules" element={<ModuleMasterPage />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/audit" element={<AuditPage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
